import React from 'react'
import { Navbar, Footer } from 'src/layouts'
import { Content } from './sections'

// Página de Política de Privacidade, reutilizando o mesmo template dos Termos de Uso
export const PoliticaDePrivacidade = () => {
  return (
    <>
      <Navbar bg="none" color="dark" />
      <Content />
      <Footer />
    </>
  )
}
